import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import VideoEmbed from '../../components/VideoEmbed';
import './CourseDetailsPage.css';

// Array of all courses with modules and lectures
const coursesData = [
  {
    id: 1,
    title: 'Introduction to Agentic AI',
    level: 'Beginner',
    duration: '4 weeks',
    lectures: 12,
    description: 'Discover the core principles of Agentic AI, understand how agent-based systems work, and learn the key differences between Agentic and traditional AI approaches. This course lays the foundation for building intelligent, autonomous agents.',
    modules: [
      {
        id: 1,
        title: 'Module 1: Introduction to AI Agents',
        lectures: [
          {
            id: 'ZIGRzOmEOn4',
            title: 'What are AI Agents?',
            duration: '15:30',
            description: 'This lecture introduces the concept of AI agents, their characteristics, and how they differ from traditional AI systems. We\'ll explore the fundamental components that make up an agent and discuss real-world examples.',
            videoLink: 'https://www.youtube.com/embed/F8NKVhkZZWI' 
          },
          {
            id: '5dZ_lvDgevk',
            title: 'History of AI Agents',
            duration: '12:45',
            description: 'Learn about the evolution of AI agents from early rule-based systems to modern deep learning approaches.',
            "videoLink": 'https://www.youtube.com/embed/OIlwOCZ9BnE'
          },
          {
            id: 'jAEPXnXlR4E',
            title: 'Types of AI Agents',
            duration: '18:20',
            videoLink: 'https://www.youtube.com/embed/fXizBc03D7E',
            description: 'Explore different types of AI agents including simple reflex agents, model-based agents, goal-based agents, and learning agents.'
          }
        ]
      },
      {
        id: 2,
        title: 'Module 2: Agent Architecture',
        lectures: [
          {
            id: '9XzuZbt1QzA',
            title: 'Perception Systems',
            duration: '20:15',
            videoLink: 'https://www.youtube.com/embed/WeGNTB098xc',
            description: 'Understand how agents perceive their environment through sensors and process input data.'
          },
          {
            id: '2pWv7Z7h4HA',
            title: 'Decision Making',
            duration: '22:30',
            videoLink: 'https://www.youtube.com/embed/xJ9KxAG1CSc',
            description: 'Learn about decision-making algorithms and strategies used by AI agents to determine actions.'
          },
          {
            id: '6QGJ3jqXxqQ',
            title: 'Action Execution',
            duration: '16:45',
            videoLink: 'https://www.youtube.com/embed/j_Q1cL6Cog4',
            description: 'Explore how agents execute actions in their environment and handle feedback.'
          }
        ]
      },
      {
        id: 3,
        title: 'Module 3: Building Simple Agents',
        lectures: [
          {
            id: '3_y_EwQnYLU',
            title: 'Agent Development Environment',
            duration: '25:10',
            videoLink: 'https://www.youtube.com/embed/zgrOwow_uTQ',
            description: 'Set up your development environment for building AI agents with popular frameworks and tools.'
          },
          {
            id: '5p248yoa3oE',
            title: 'Your First AI Agent',
            duration: '30:45',
            videoLink: 'https://www.youtube.com/embed/LMPh5cwtWig',
            description: 'Build a simple AI agent from scratch and understand its components and behavior.'
          },
          {
            id: '8ZtInClXe1Q',
            title: 'Testing and Debugging',
            duration: '22:15',
            videoLink: 'https://www.youtube.com/embed/4u64WEuQHYE',
            description: 'Learn techniques for testing and debugging AI agents to ensure they behave as expected.'
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Building AI Agents with LangGraph',
    level: 'Intermediate',
    duration: '6 weeks',
    lectures: 15,
    description: 'Learn to design, develop, and deploy AI agents using the LangGraph framework. This course covers agent architectures, multi-agent collaboration, and practical implementation strategies for real-world applications.',
    modules: [
      {
        id: 1,
        title: 'Module 1: LangGraph Basics',
        lectures: [
          {
            id: 'lang1',
            title: 'Introduction to LangGraph',
            duration: '14:00',
            videoLink: 'https://www.youtube.com/embed/5h-JBkySK34',
            description: 'Overview of the LangGraph framework and its core concepts.'
          },
          {
            id: 'lang2',
            title: 'Setting Up LangGraph',
            duration: '18:30',
            videoLink: 'https://www.youtube.com/embed/PqS1kib7RTw',
            description: 'Step-by-step guide to installing and configuring LangGraph for your projects.'
          }
        ]
      },
      {
        id: 2,
        title: 'Module 2: Agent Architectures',
        lectures: [
          {
            id: 'lang3',
            title: 'Designing Agent Workflows',
            duration: '20:00',
            videoLink: 'https://www.youtube.com/embed/aHCDrAbH_go',
            description: 'Learn how to design workflows for single and multi-agent systems in LangGraph.'
          },
          {
            id: 'lang4',
            title: 'State Management',
            duration: '17:45',
            videoLink: 'https://www.youtube.com/embed/BDFP6VSOARk',
            description: 'Understand how to manage agent state and transitions in LangGraph.'
          }
        ]
      },
      {
        id: 3,
        title: 'Module 3: Real-World Applications',
        lectures: [
          {
            id: 'lang5',
            title: 'Deploying LangGraph Agents',
            duration: '22:10',
            videoLink: 'https://www.youtube.com/embed/YWVuBLSbNWE',
            description: 'Best practices for deploying and scaling LangGraph agents in production.'
          },
          {
            id: 'lang6',
            title: 'Case Studies',
            duration: '19:30',
            videoLink: 'https://www.youtube.com/embed/sn79oS4MZFI',
            description: 'Explore real-world case studies of LangGraph agent deployments.'
          }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Build AI Agents Using CrewAI',
    level: 'Advanced',
    duration: '8 weeks',
    lectures: 18,
    description: 'Master advanced agent-building techniques with CrewAI. Explore complex agent systems, multi-agent coordination, and optimization strategies to create robust, scalable AI solutions.',
    modules: [
    {
      id: 1,
      title: 'Everything about Crew AI',
      lectures: [
        {
          id: 'W0RFvnXpt0A',
          title: 'Introduction to Crew AI with Example',
          duration: '8:51',
          videoLink: 'https://www.youtube.com/embed/W0RFvnXpt0A',
          description: 'Overview and example of Crew AI.'
        },
        {
          id: 'kSOTtYzgEw',
          title: 'Explained how to create/what is Agents in Crew AI',
          duration: '5:01',
          videoLink: 'https://www.youtube.com/embed/zn0d3-Wv8wc',
          description: 'How to create agents and what agents are in Crew AI.'
        },
        {
          id: '8cznOaMiJAw',
          title: 'Explained everything about Tasks in CrewAI',
          duration: '14:22',
          videoLink: 'https://www.youtube.com/embed/dXSkFvJgsM4',
          description: 'Detailed explanation of tasks in CrewAI.'
        },
        {
          id: '10z4l8w6QwA',
          title: 'Explained about CREW in CrewAI',
          duration: '10:24',
          videoLink: 'https://www.youtube.com/embed/tjzY9yrdyeA',
          description: 'Understanding the CREW concept in CrewAI.'
        },
        {
          id: '18z4l8w6QwA',
          title: 'Explained about Flows in CrewAI',
          duration: '18:17',
          videoLink: 'https://www.youtube.com/embed/BgAMu7mvoYo',
          description: 'How flows work in CrewAI.'
        },
        {
          id: '11z4l8w6QwA',
          title: 'Explained about Knowledge in Crew AI',
          duration: '11:48',
          videoLink: 'https://www.youtube.com/embed/6p6u72hGNy0',
          description: 'Knowledge management in CrewAI.'
        },
        {
          id: '9z4l8w6QwA',
          title: 'Explained about Memory in Crew AI',
          duration: '9:42',
          videoLink: 'https://www.youtube.com/embed/HGYrOxkLDnY',
          description: 'Memory features in CrewAI.'
        },
        {
          id: '7z4l8w6QwA',
          title: 'AI Receptionist: Crew AI, Whisper & ElevenLabs Powering Hotel',
          duration: '7:26',
          videoLink: 'https://www.youtube.com/embed/T4Ddif7Nggs',
          description: 'Case study: AI Receptionist using CrewAI, Whisper, and ElevenLabs.'
        }
      ]
    }
  ]
}
];

const CourseDetailsPage = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeModule, setActiveModule] = useState(1);
  const [activeLecture, setActiveLecture] = useState(null);
  const [expandedModules, setExpandedModules] = useState([1]);

  useEffect(() => {
    setLoading(true);
    const courseId = parseInt(id, 10);
    const foundCourse = coursesData.find(c => c.id === courseId);
    setTimeout(() => {
      setCourse(foundCourse || null);
      if (foundCourse && foundCourse.modules.length > 0 && foundCourse.modules[0].lectures.length > 0) {
        setActiveLecture(foundCourse.modules[0].lectures[0]);
        setActiveModule(foundCourse.modules[0].id);
        setExpandedModules([foundCourse.modules[0].id]);
      }
      setLoading(false);
    }, 500);
  }, [id]);

  const toggleModule = (moduleId) => {
    if (expandedModules.includes(moduleId)) {
      setExpandedModules(expandedModules.filter(id => id !== moduleId));
    } else {
      setExpandedModules([...expandedModules, moduleId]);
    }
  };

  const selectLecture = (module, lecture) => {
    setActiveModule(module.id);
    setActiveLecture(lecture);
    if (!expandedModules.includes(module.id)) {
      setExpandedModules([...expandedModules, module.id]);
    }
  };

  const navigateToLecture = (direction) => {
    if (!course || !activeLecture) return;
    const currentModuleIndex = course.modules.findIndex(m => m.id === activeModule);
    const currentLectureIndex = course.modules[currentModuleIndex].lectures.findIndex(l => l.id === activeLecture.id);

    if (direction === 'prev') {
      if (currentLectureIndex > 0) {
        setActiveLecture(course.modules[currentModuleIndex].lectures[currentLectureIndex - 1]);
      } else if (currentModuleIndex > 0) {
        const prevModule = course.modules[currentModuleIndex - 1];
        const prevLecture = prevModule.lectures[prevModule.lectures.length - 1];
        setActiveModule(prevModule.id);
        setActiveLecture(prevLecture);
        if (!expandedModules.includes(prevModule.id)) {
          setExpandedModules([...expandedModules, prevModule.id]);
        }
      }
    } else if (direction === 'next') {
      if (currentLectureIndex < course.modules[currentModuleIndex].lectures.length - 1) {
        setActiveLecture(course.modules[currentModuleIndex].lectures[currentLectureIndex + 1]);
      } else if (currentModuleIndex < course.modules.length - 1) {
        const nextModule = course.modules[currentModuleIndex + 1];
        const nextLecture = nextModule.lectures[0];
        setActiveModule(nextModule.id);
        setActiveLecture(nextLecture);
        if (!expandedModules.includes(nextModule.id)) {
          setExpandedModules([...expandedModules, nextModule.id]);
        }
      }
    }
  };

  if (loading) {
    return (
        <main className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading course...</p>
        </main>
    );
  }

  if (!course) {
    return (
        <main className="error-container">
          <h2>Course Not Found</h2>
          <p>The course you&apos;re looking for doesn&apos;t exist or has been removed.</p>
          <Link to="/courses" className="btn-primary">Back to Courses</Link>
        </main>
    );
  }

  return (
      <main>
        <section className="course-header">
          <div className="container">
            <div className="course-breadcrumb">
              <Link to="/courses">Courses</Link> &gt; {course.title}
            </div>
            <h1>{course.title}</h1>
            <div className="course-meta">
              <span className="course-level">{course.level}</span>
              <span className="course-duration">{course.duration}</span>
              <span className="course-lectures">{course.lectures} lectures</span>
            </div>
            <p className="course-description">{course.description}</p>
          </div>
        </section>

        <section className="course-content">
          <div className="container">
            <div className="content-wrapper">
              <div className="sidebar">
                <div className="course-progress">
                  <div className="progress-bar">
                    <div className="progress" style={{ width: '25%' }}></div>
                  </div>
                  <p>25% Complete</p>
                </div>

                <div className="course-modules">
                  <h3>Course Modules</h3>
                  <ul className="module-list">
                    {course.modules.map(module => (
                        <li className="module" key={module.id}>
                          <div
                              className="module-header"
                              onClick={() => toggleModule(module.id)}
                          >
                            <h4>{module.title}</h4>
                            <span className="module-toggle">
                          {expandedModules.includes(module.id) ? '-' : '+'}
                        </span>
                          </div>
                          <ul className={`lecture-list ${expandedModules.includes(module.id) ? 'active' : ''}`}>
                            {module.lectures.map(lecture => (
                                <li
                                    className={`lecture ${activeLecture && activeLecture.id === lecture.id ? 'active' : ''}`}
                                    key={lecture.id}
                                    onClick={() => selectLecture(module, lecture)}
                                >
                                  <span className="lecture-title">{lecture.title}</span>
                                  <span className="lecture-duration">{lecture.duration}</span>
                                </li>
                            ))}
                          </ul>
                        </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="main-content">
                {activeLecture && (
                    <>
                      <div className="video-container">
                        <VideoEmbed
                            videoLink={activeLecture.videoLink}
                            title={activeLecture.title}
                            onComplete={() => navigateToLecture('next')}
                        />
                      </div>

                      <div className="lecture-info">
                        <h2>{activeLecture.title}</h2>
                        <p>{activeLecture.description}</p>
                      </div>

                      <div className="lecture-resources">
                        <h3>Lecture Resources</h3>
                        <ul>
                          <li><button className="resource-link"><span className="resource-icon">📄</span> Lecture Slides</button></li>
                          <li><button className="resource-link"><span className="resource-icon">📝</span> Lecture Notes</button></li>
                          <li><button className="resource-link"><span className="resource-icon">📚</span> Additional Reading</button></li>
                        </ul>
                      </div>

                      <div className="lecture-navigation">
                        <button
                            className="btn-prev-lecture"
                            onClick={() => navigateToLecture('prev')}
                            disabled={
                                course.modules[0].lectures[0].id === activeLecture.id
                            }
                        >
                          Previous Lecture
                        </button>
                        <button
                            className="btn-next-lecture"
                            onClick={() => navigateToLecture('next')}
                            disabled={
                                course.modules[course.modules.length - 1].lectures[
                                course.modules[course.modules.length - 1].lectures.length - 1
                                    ].id === activeLecture.id
                            }
                        >
                          Next Lecture
                        </button>
                      </div>
                    </>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
  );
};

export default CourseDetailsPage;